import { Navigate, useLocation } from "src/router";
import { PageSpinner } from "src/components/loading";
import { lazyNamed } from "src/utils/lazy-named";

import { useEventSourceOutletContext } from "./source/outlet";
import { useCanAccessEventSourceData } from "./source/use-can-access-data";

const Debugger = lazyNamed(() => import("./source/debugger"), "Debugger");

export const DebuggerRoute = () => {
  const location = useLocation();
  const { source } = useEventSourceOutletContext();
  const { shouldGateDebugger, canAccessData, isLoading } =
    useCanAccessEventSourceData({
      sourceId: source.id,
    });

  if (shouldGateDebugger && isLoading) {
    return <PageSpinner />;
  }

  if (shouldGateDebugger && !canAccessData) {
    return (
      <Navigate
        to={{ pathname: "../overview", search: location.search }}
        relative="path"
        replace
      />
    );
  }

  return <Debugger />;
};
